import classNames from 'classnames';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  .skeleton-box{
    height: 33px;
    width:113px;
    border-radius: 25px;
    margin-right: 5px;
    &.marginTopBottom {
      margin-top: 11.3px;
      margin-bottom: 11.3px;
    }
  }
`;

type Props = {
  marginTopBottom?: boolean,
} & typeof defaultProps;

const defaultProps = {
  marginTopBottom: false,
};

const TagSkeleton = function TagSkeleton(props: Props) {
  const { marginTopBottom } = props;
  return (
    <Wrapper>
      <span className={classNames('skeleton-box', { marginTopBottom })} />
    </Wrapper>
  );
};

TagSkeleton.defaultProps = defaultProps;
export default TagSkeleton;
